<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">

        <div class="d-flex align-items-center">
          <h1 class="flex-grow-1" data-test="pageTitle">All Check-ins</h1>
          <span
            v-tooltip.bottom="'Add Check-in'"
            @click="buildCheckinModal()"
            class="btn btn-sm btn-ghost-primary text-gray-500 leading-none"
            data-toggle="modal" data-target="#myModal"
            data-test="addCheckinButton" >
              <i class="far fa-plus-circle text-xl"></i>
          </span>
        </div>

        <div class="card checkins-table">
          <vuetable ref="vuetable"
            api-url="/api/checkins"
            :fields="fields"
            data-path="data"
            pagination-path=""
            :css="css.table"
            :sort-order="sortOrder"
            :sort-params="getSortParam"
            :multi-sort="false"
            :append-params="moreParams"
            :no-data-template="emptyText"
            @vuetable:load-success="onDataLoaded"
            @vuetable:pagination-data="onPaginationData">


            <div slot="checkin_type" slot-scope="props" class="d-flex align-items-top">
              <!-- <div class="checkin-type-bullet rounded-circle bg-red-500 mr-2 mt-2" :class="props.rowData.checkin_type.css_class_name"></div> -->
              <div class="flex-grow-1">
                <span class="cursor-pointer" data-toggle="modal" data-target="#checkinModal" @click="showCheckin(props.rowData.id)">
                  <a href="#" 
                    class="cursor-pointer badge text-base"
                    :class="props.rowData.checkin_type.css_class_name"
                    @click="showCheckin(props.rowData.id)"
                    data-toggle="modal" data-target="#checkinModal"
                    data-test="showCheckin">
                    {{ props.rowData.checkin_type.label }}</a>

                  <span class="text-gray-500">with</span> {{ props.rowData.checkinable.display_name }}
                </span>
                
                <router-link 
                  v-if="props.rowData.checkinable_type == 'App\\Physician'"
                  :to="{ name: 'physicians.show', params: { id: props.rowData.checkinable.id } }"
                  class="btn btn-sm btn-ghost-secondary leading-none" data-test="showPhysician">
                  <i v-tooltip.bottom="'View Profile'" class="fal fa-user-md"></i>
                </router-link>
                <router-link 
                  v-if="props.rowData.checkinable_type == 'App\\Group'"
                  :to="{ name: 'groups.show', params: { id: props.rowData.checkinable.id } }"
                  class="btn btn-sm btn-ghost-secondary leading-none" data-test="showGroup">
                  <i v-tooltip.bottom="'View Profile'" class="fal fa-users-medical"></i>
                </router-link>                
                <div v-if="props.rowData.service_lines" class="d-none d-sm-block">
                  <span v-for="service_line in props.rowData.service_lines" class="badge bg-orange-100 text-orange-700 text-weight-normal mr-1">{{ service_line.label }}</span>
                </div>

                <div v-if="$root.$mq == 'xs'" class="d-flex mt-1 text-sm text-gray-600 align-items-center">
                  <div v-if="props.rowData.checkin_user" class="rounded-circle circle-cropped avatar-xs mr-1">
                    <img :src="props.rowData.checkin_user.photo_url" class="img-fluid">
                  </div>
                  <span v-if="props.rowData.checkin_user">{{ props.rowData.checkin_user.display_name }}</span>
                  <span v-else>unknown</span> 
                </div>               
              </div>
            </div>


            <div slot="checkin_user" slot-scope="props" class="d-flex align-items-center text-sm text-gray-600 leading-tight">
              <div v-if="props.rowData.checkin_user" class="rounded-circle circle-cropped avatar-xs mr-1">
                <img :src="props.rowData.checkin_user.photo_url" class="img-fluid">
              </div>
              <span v-if="props.rowData.checkin_user">{{ props.rowData.checkin_user.display_name }}</span>
              <span v-else>unknown</span>
            </div>

            <div slot="created_at" slot-scope="props" class="d-flex align-items-center">
              <span
                @click="showCheckin(props.rowData.id)"
                data-toggle="modal" data-target="#checkinModal"
                class="flex-grow-1 text-sm text-gray-600 leading-tight">
                {{ moment(props.rowData.created_at).format('MMM D, YYYY') }}
              </span> 

              <div class="ml-2 drop-down dropleft" :id="'checkin-' + props.rowData.id">
                <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-test="contextMenu">
                  <i class="far fa-ellipsis-h text-xl"></i>
                </a>
                <div class="dropdown-menu py-0" aria-labelledby="dropdownMenuLink">
                  <span class="dropdown-item" @click="showCheckin(props.rowData.id)" data-toggle="modal" data-target="#checkinModal" data-test="showCheckin">View Details</span>
                  <span class="dropdown-item" v-if="props.rowData.can.delete" @click="deleteCheckin(props.rowData.id)" data-test="deleteCheckin">Delete Check-in</span>
                </div>
              </div>

                           
            </div>

          </vuetable>
        </div>

        <div class="background-fix vuetable-pagination d-flex mb-3">
          <vuetable-pagination-info ref="paginationInfo" info-class="pagination-info" class="flex-fill" info-template="{from} to {to} of {total} items" />
          <vuetable-pagination-bootstrap ref="pagination" :css="css.pagination" @vuetable-pagination:change-page="onChangePage" class="flex-fill text-right" />
        </div>

      </div>
    </div>

    <checkin-view-modal :showing_checkin="showing_checkin" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

  import Vuetable from 'vuetable-2'
  import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
  import VuetablePaginationBootstrap from '../../components/VuetablePaginationBootstrap.vue'

  import CheckinViewModal from '../../components/CheckinViewModal'

  export default {
      
    mixins: [BreadcrumbsManager],

    components: {
      Vuetable,
      VuetablePaginationInfo,
      CheckinViewModal,
      VuetablePaginationBootstrap,
    },

    data() {
      return {
        emptyText: 'Loading...please wait',
        
        fields: [      
          {
            name: 'checkin_type',
            title: 'Type',
            sortField: 'checkin_type_id',           
          },
          {
            name: 'checkin_user',
            title: 'Made by',
            sortField: 'user_id',
            titleClass: 'd-none d-sm-block',
            dataClass: 'd-none d-sm-block',            
          },          
          {
            name: 'created_at',
            title: 'Date',
            sortField: 'created_at',
          },           

        ],

        css: {
          table: {
            tableClass: 'table',
            ascendingIcon: 'fas fa-sort-alpha-down',
            descendingIcon: 'fas fa-sort-alpha-up'
          },

          pagination: {
            wrapperClass: 'pagination',
            activeClass: 'active',
            disabledClass: 'disabled',
            pageClass: 'page',
            linkClass: 'link',
            icons: {
              first: '',
              prev: '',
              next: '',
              last: '',
            },
          },

          icons: {
            first: 'fas fa-angle-double-left',
            prev: 'fas fa-angle-left',
            next: 'fas fa-angle-right',
            last: 'fas fa-angle-double-right',
          },
        },

        sortOrder: [
          {
            field: 'created_at',
            direction: 'desc',
          }
        ],

        moreParams: {
        },

        checkin_options: {
          physician: null,
        },

        showing_checkin: { //declare arrays so vue doesn't complain
          checkin_type: [], 
          checkin_user: [],
          checkinable: [],
          service_lines: [],
        },

      };
    },

    created() {
    },

    activated() {
      this.setBreadcrumbs([
        { text: 'Home', to: { name: 'home' } },
        { text: 'All Check-Ins', to: { name: 'checkins.index' } },
      ]); 
    },

    mounted() {
      this.$root.$on('checkin_updated', data => {
        this.$refs.vuetable.tableData.splice(this.checkinIndex(data.id), 1); //remove
        this.$refs.vuetable.tableData.push(data); //re-add (TODO: this adds to the bottom)
        this.showCheckin(data.id);//and re-load modal
      });

      this.$root.$on('checkinadded', data => {
        this.$refs.vuetable.refresh();
      });
    },

    methods: {
      buildCheckinModal() {
        this.$root.$emit('build_checkin_modal', { checkin_options: this.checkin_options });
      },

      getSortParam(sortOrder) {
        return sortOrder.map(function(sort) {
          return (sort.direction === 'desc' ? '-' : '') + sort.sortField
        }).join(',')
      },

      onDataLoaded() {
        Vue.nextTick( () => {
          if (this.$refs.vuetable.tableData.length == 0) {
            this.emptyText = 'No records found';
          }
        });
      },

      onPaginationData(paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      },

      onChangePage(page) {
        this.$refs.vuetable.changePage(page)
      },

      showCheckin(checkin_id) {
        var show_checkin = this.$refs.vuetable.tableData.find(function (checkins) { 
        return checkins.id === checkin_id;
          });
        this.showing_checkin = show_checkin;
      },

      checkinIndex(checkin_Id) {
        return this.$refs.vuetable.tableData.findIndex((checkin) => {
            return checkin.id === checkin_Id;
        });
      },

      deleteCheckin(checkin_id) {
        Swal.fire({
              title: 'Are you sure?',
              text: 'You will not be able to recover this check-in.',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Delete check-in',
              cancelButtonText: 'Keep check-in',
              animation: false,
            }).then((result) => {
              if (result.value) {
                    axios.delete('/api/checkins/' + checkin_id, checkin_id).then(() => {
                        this.$refs.vuetable.refresh();
                        //this.$refs.vuetable.tableData.splice(this.checkinIndex(checkin_id), 1);
                    })
                }
            }
        );
      },
    },

    computed: mapState(['config', 'perms']),
  }
</script>